import React from 'react';

import './CollegeDistributeSelectPayee.scss';

import { dispatchPageLoad } from '../../../redux/utils/analytics-helper';
import { COLLEGE_DISTRIBUTE_PAYEE_OPTIONS } from '../../../settings/settings';
import Checkbox from '../../Shared/Checkbox/Checkbox';
import RadioButton from '../../Shared/RadioButton/RadioButton';

const CollegeDistributeSelectPayee = ({
  agreementID,
  distributionPayeeDisclaimerAccepted,
  payee,
  showPayeeDisclaimer,
  updateDistributionPayee,
  updateDistributionPayeeDisclaimer,
}) => (
  <div className="college-distribute-payee-container">
    Select Payee (Taxable Party)
    <div className="college-distribute-payee">
      <RadioButton
        checked={payee === COLLEGE_DISTRIBUTE_PAYEE_OPTIONS.ACCOUNT_HOLDER}
        className="e2e-account-holder-payee-checkbox"
        displayErrorMessage
        tabIndex="5"
        labelText={COLLEGE_DISTRIBUTE_PAYEE_OPTIONS.ACCOUNT_HOLDER}
        name="distributionPayee"
        onChange={() =>
          updateDistributionPayee({
            agreementID,
            payee: COLLEGE_DISTRIBUTE_PAYEE_OPTIONS.ACCOUNT_HOLDER,
          })
        }
      />
    </div>
    <div className="college-distribute-payee">
      <RadioButton
        checked={payee === COLLEGE_DISTRIBUTE_PAYEE_OPTIONS.BENEFICIARY}
        className="e2e-beneficiary-payee-checkbox"
        displayErrorMessage
        labelText={COLLEGE_DISTRIBUTE_PAYEE_OPTIONS.BENEFICIARY}
        name="distributionPayee"
        onChange={() => {
          updateDistributionPayee({
            agreementID,
            payee: COLLEGE_DISTRIBUTE_PAYEE_OPTIONS.BENEFICIARY,
          });
          //TODO: Bene Modal update
          //dispatch(openModal(PAY_TAX_INFORMATION, { fund }));
        }}
      />
    </div>
    {showPayeeDisclaimer && (
      <div className="college-distribute-payee-disclaimer-container">
        <Checkbox
          ariaLabel="college distribute payee disclaimer"
          checked={distributionPayeeDisclaimerAccepted}
          id={`payee-disclaimer-checkbox-${agreementID}`}
          disabled={!payee}
          inline
          onClick={(distributionPayeeDisclaimerAccepted) => {
            updateDistributionPayeeDisclaimer({
              agreementID,
              distributionPayeeDisclaimerAccepted,
            });
            if (distributionPayeeDisclaimerAccepted) {
              dispatchPageLoad('College distribute payee disclaimer accepted');
            }
          }}
        />
        <label htmlFor={`payee-disclaimer-checkbox-${agreementID}`}>
          I certify that the payee selected is an owner on the bank account
          selected.
        </label>
      </div>
    )}
  </div>
);

export default CollegeDistributeSelectPayee;
